import type { CourseCategoryI, CourseCategoryFilterI } from 'types';
import { BaseApi } from './base-api';

class CourseCategoriesApi extends BaseApi<CourseCategoryI, CourseCategoryFilterI> {}

export const courseCategoriesApi = new CourseCategoriesApi('/course-categories');

export default courseCategoriesApi;
